const WRITER_API_ROUTE = `${process.env.REACT_APP_WRITER_API_ROUTE}`;

const PERMISSION_API_ROUTE = `${WRITER_API_ROUTE}/permission`

export const GET_ALL_PERMISSIONS_API_ROUTE = `${PERMISSION_API_ROUTE}/get-all-permissions`;
export const GET_ROLES_PERMISSIONS_API_ROUTE = `${PERMISSION_API_ROUTE}/get-roles-permissions`;
export const SAVE_ROLE_PERMISSIONS_API_ROUTE = `${PERMISSION_API_ROUTE}/save-role-permissions`;
export const GET_ALL_USERS_API_ROUTE = `${PERMISSION_API_ROUTE}/get-all-users`;
export const GET_USERS_PERMISSIONS_API_ROUTE = `${PERMISSION_API_ROUTE}/get-users-permissions`;
export const SAVE_USER_PERMISSIONS_API_ROUTE = `${PERMISSION_API_ROUTE}/save-user-permissions`;